import { render, staticRenderFns } from "./EditCustomerForm.vue?vue&type=template&id=98d4e846&scoped=true&"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js&"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerForm.vue?vue&type=style&index=0&id=98d4e846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d4e846",
  null
  
)

export default component.exports